var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{staticClass:"project-member"},[_c('div',{staticClass:"project-member__inner"},[_c('h2',{staticClass:"title"},[_vm._v("project member")]),_vm._v(" "),_c('MemberList',{attrs:{"members":_vm.members}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }